export const getSelectedChannelTypeFilter = (state) => state.channelList.selectedChannelTypeFilter;
